import { render, staticRenderFns } from "./levels.vue?vue&type=template&id=af228ab2"
import script from "./levels.vue?vue&type=script&lang=js"
export * from "./levels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports